import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../contexts/authContext";
import {db} from "../firebase/firebase";
import courseVid from "../../src/CourseClip.mp4"
import logo from "../PFC_Images/PFC46.png";

import { ReactComponent as LOGO } from "../../src/customIcons/PFC.svg";

const SplashScreen = () => {

    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to Home after 5 seconds
        const timer = setTimeout(() => {
            // // navigate(defaultPage);
            navigate("/content");
        }, 4500);

        return () => clearTimeout(timer); // Cleanup timer on unmount
    }, [navigate]);

    const { currentUser } = useAuth();
    const [fname, setFname] = useState("");

    useEffect(() => {
        const fetchUserName = async () => {
            if (currentUser) {
                try {
                    // Check if user data is in localStorage
                    const storedUserData = localStorage.getItem(`userName_${currentUser.uid}`);

                    if (storedUserData) {
                        // Use the stored user data
                        const userData = JSON.parse(storedUserData);
                        setFname(userData.fname);
                        // setAccountLevel(userData.accountLevel);
                    } else {
                        // Fetch user document from Firestore based on the current user's UID
                        const userDoc = await db.collection('Users').doc(currentUser.uid).get();
                        if (userDoc.exists) {
                            // Get the user's name from the document data
                            const userData = userDoc.data();
                            setFname(userData.fname);
                            // setAccountLevel(userData.accountLevel);
                            // Save user data to localStorage
                            localStorage.setItem(`userName_${currentUser.uid}`, JSON.stringify(userData));
                        } else {
                            console.log('User document not found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                }
            }
        };

        fetchUserName();
    }, [currentUser]);

   
    

   
    const [animateOut, setAnimateOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setAnimateOut(true), 4200); // after flipPopSwoosh
        return () => clearTimeout(timer);
    }, []);


    return (


        <div className={`relative bg-darkMainColor flex items-center justify-center h-dvh bg-gradient-to-br from-bgDark to-green-900 overflow-hidden`}>
            {/*/!* Spiral Background *!/*/}
            {/*<div className="absolute animate-fadeIn inset-0 flex items-center justify-center">*/}
            {/*    <div className="w-full h-full animate-heartBeatSlow bg-hypnotic-spiral"></div>*/}
            {/*</div>*/}
            
            
            <div className={`flex flex-col items-center justify-center animate-fadeIn ${animateOut ? 'animate-fadeOut' : ''}`}>
                
                {/* Video */}
                <div className={`absolute inset-0 flex items-center justify-center`}>
                    {/*<div className="w-full h-full animate-expandIn bg-hypnotic-spiral"></div>*/}
                    {/*<img*/}
                    {/*    alt=""*/}
                    {/*    src={course}*/}
                    {/*    className="absolute inset-0 object-cover opacity-50 size-full"*/}
                    {/*/>*/}
                    
                    <video
                        src={courseVid}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="absolute inset-0 object-cover opacity-50 size-full"
                    />
                
                </div>
                
                {/* GroLinkz Logo and Text */}
                <div className="text-center flex flex-col relative z-10">
                    
                    <div className="flex justify-center animate-epicReveal">
                        {/*<LOGO className={`size-52 z-50 text-green-600`}/>*/}
                        <img
                            alt=""
                            src={logo}
                            className="size-52 z-50"
                        />
                    </div>
                    
                    <h1 className={`animate-flipPopSwoosh text-7xl font-semibold text-white tracking-widest`}>Plant
                        Food</h1>
                
                </div>
                
                <h2 className={`z-50 animate-flipPopSwoosh text-white text-opacity-50 text-2xl -mt-4 font-semibold`}>Welcome {fname}!</h2>
                
            
            </div>
        
        
        </div>
    
    );
};

export default SplashScreen;
